import _slicedToArray from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["className", "overlaySrc", "src", "borderRadius"];

var _templateObject, _templateObject2, _templateObject3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from "react";
import PropTypes from "prop-types";
import Styled from "styled-components";
var ImageWrap = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      width: ", ";\n\t\t\theight: ", ";\n\t\t\tposition: relative;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var ImageStyle = Styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      position: absolute;\n\t\t\ttop: 0px;\n\t\t\tleft: 0px;\n      transition: opacity ease-in 0.3;\n      opacity: ", ";\n      border-radius: ", ";\n"])), function (props) {
  return props.highResImageLoaded ? 1 : 0;
}, function (props) {
  return props.borderRadius;
});
var OverlayImageStyle = Styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      position: absolute;\n\t\t\ttop: 0px;\n\t\t\tleft: 0px;\n      filter: blur(1px);\n      transition: opacity ease-in 0.3;\n      opacity: ", ";\n      border-radius: ", ";\n"])), function (props) {
  return props.highResImageLoaded ? 0 : 1;
}, function (props) {
  return props.borderRadius;
});
export var ProgressiveImage = function ProgressiveImage(_ref) {
  var className = _ref.className,
      overlaySrc = _ref.overlaySrc,
      src = _ref.src,
      borderRadius = _ref.borderRadius,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      highResImageLoaded = _useState2[0],
      setHighResImageLoaded = _useState2[1];

  return /*#__PURE__*/React.createElement(ImageWrap, _extends({
    className: className
  }, restProps), /*#__PURE__*/React.createElement(ImageStyle, _extends({}, restProps, {
    highResImageLoaded: highResImageLoaded,
    borderRadius: borderRadius,
    onLoad: function onLoad() {
      setHighResImageLoaded(true);
    },
    src: src
  })), /*#__PURE__*/React.createElement(OverlayImageStyle, _extends({
    highResImageLoaded: highResImageLoaded,
    borderRadius: borderRadius,
    src: overlaySrc
  }, restProps)));
};
ProgressiveImage.propTypes = {
  overlaySrc: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  borderRadius: PropTypes.string,
  className: PropTypes.string
};
ProgressiveImage.defaultProps = {
  className: "",
  borderRadius: "0px"
};